import { render } from "./QuestCurrentTask.vue?vue&type=template&id=526b0a8c"
import script from "./QuestCurrentTask.vue?vue&type=script&lang=js"
export * from "./QuestCurrentTask.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/QuestCurrentTask.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "526b0a8c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('526b0a8c', __exports__)) {
    api.reload('526b0a8c', __exports__)
  }
  
  module.hot.accept("./QuestCurrentTask.vue?vue&type=template&id=526b0a8c", () => {
    api.rerender('526b0a8c', render)
  })

}


export default __exports__